<div class="line-item w-100">
  <img
    height="110"
    width="110"
    *ngIf="lineItem.merchandise.image?.transformedSrc"
    [ngSrc]="lineItem.merchandise.image?.transformedSrc ?? ''"
  />
  <div class="d-flex flex-column w-100">
    <div class="line-item inner w-100">
      <a
        class="d-flex flex-column"
        [routerLink]="['/products/' + lineItem.merchandise.product.handle]"
      >
        <div class="title">
          {{ lineItem.merchandise.product.title | titleExtractor }}
        </div>
        <div class="mt-2 mb-1" *ngIf="!_bundle">
          <ng-container
            *ngIf="lineItem.merchandise.product.title.split('|').length != 5"
          >
            <div
              class="property"
              *ngFor="let option of lineItem.merchandise.selectedOptions"
            >
              {{ option.value }}
            </div>
          </ng-container>
          <div class="property">
            {{ lineItem.merchandise.product.title.split("|")[3] }}
          </div>
          <div
            class="property"
            *ngIf="lineItem.merchandise.product.title.split('|').length == 5"
          >
            {{ lineItem.merchandise.product.title.split("|")[4] }}
          </div>
          <div
            class="property"
            *ngIf="lineItem.merchandise.product.title.split('|').length == 5"
          >
            {{ lineItem.merchandise.product.title.split("|")[5] }}
          </div>
        </div>
      </a>
      <div class="d-flex flex-column ms-auto">
        <div class="price ms-3">
          <div>
            <s
              *ngIf="
                lineItem?.cost?.subtotalAmount?.amount &&
                lineItem.cost.subtotalAmount.amount !==
                  lineItem.cost.totalAmount.amount
              "
              >{{ lineItem.cost.subtotalAmount.amount | currency }}</s
            >
          </div>
          <div *ngIf="lineItem.cost.totalAmount.amount == '0.0'">Free Gift</div>
          <div *ngIf="lineItem.cost.totalAmount.amount != '0.0'">
            {{ lineItem.cost.totalAmount.amount | currency }}
          </div>
        </div>
      </div>
    </div>
    <div class="line-item justify-content-between mt-2 mb-3 mb-lg-0">
      <app-qty *ngIf="!_gwpMode" [lineItem]="lineItem"></app-qty>
      <div class="remove action" *ngIf="!_gwpMode" (click)="remove()">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.5358 4.88889C10.2569 4.88775 9.98833 5.00231 9.78553 5.20889C9.58953 5.40978 9.48329 5.68 9.48329 5.95556V7.02223H14.5167V5.95556C14.5167 5.68 14.4096 5.40978 14.2145 5.20889C14.0117 5.00231 13.7431 4.88775 13.4642 4.88889H10.5358ZM15.3402 7.02223V5.95556C15.3402 5.43112 15.1376 4.93067 14.7835 4.56623C14.4275 4.20158 13.9551 3.99883 13.4642 4.00001H10.5358C10.0449 3.99883 9.57253 4.20158 9.21647 4.56623C8.86235 4.93067 8.66059 5.43023 8.66059 5.95556V7.02223H5V7.91111H6.46424V18.0444C6.46424 18.5689 6.66682 19.0693 7.02012 19.4338C7.37638 19.7986 7.84913 20.0014 8.34024 20H15.6606C16.1514 20.0012 16.6238 19.7984 16.9799 19.4338C17.334 19.0693 17.5358 18.5698 17.5358 18.0444V7.91111H19V7.02223H15.3402ZM7.28776 7.91111H16.7122V18.0444C16.7122 18.32 16.606 18.5902 16.4108 18.7911C16.2078 18.9979 15.9389 19.1125 15.6598 19.1111H8.34106C8.06193 19.1125 7.793 18.9979 7.59 18.7911C7.49554 18.6952 7.42011 18.5795 7.3683 18.4512C7.31649 18.3228 7.28937 18.1844 7.28859 18.0444L7.28776 7.91111ZM10.9475 10.6667V16H10.124V10.6667H10.9475ZM13.876 10.6667V16H13.0525V10.6667H13.876Z"
            fill="black"
          />
        </svg>
      </div>
    </div>
  </div>
</div>
<div class="line-item properties w-100" *ngIf="_bundle">
  <div class="contents p-3 w-100">
    <div
      class="property"
      *ngFor="let option of lineItem.merchandise.selectedOptions"
    >
      {{ option.value }}
    </div>
  </div>
</div>
<div
  class="line-item properties w-100 mt-3"
  *ngIf="lineItem.attributes && lineItem.attributes.length > 0"
>
  <div class="contents py-3 w-100">
    <div class="property" *ngFor="let option of lineItem.attributes">
      {{ option.key }}: {{ option.value }}
    </div>
  </div>
</div>
